<template>
  <div class="wrapper"> 
    <div class="left-menu">
      <div class="portal-header logo-header">
        <img src="@/assets/img/logo-light.png" />
      </div>
      <div class="block-menu-btn">
        <!-- <div class="count-notifications">5</div> -->
        <!-- <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'notifications' }" 
          :class="{ active: isActive('notifications') }">
            Уведомления
        </router-link> -->
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'orders' }" 
          :class="{ active: isActive('orders') }"
        >
          Заказы
          <div 
            v-if="!isEmpty(allCountNewMessages)" 
            class="count-all-new-messages"
          >
            {{ allCountNewMessages }}
          </div>
        </router-link>
        <!-- <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'claims' }" 
          :class="{ active: isActive('claims') }">
            Претензии
        </router-link>
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'reports' }" 
          :class="{ active: isActive('reports') }">
            Отчеты
        </router-link>
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'appeals' }" 
          :class="{ active: isActive('appeals') }">
            Обращения
        </router-link> -->
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'kp' }" 
          :class="{ active: isActive('kp') }">
            КП
        </router-link>
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'price' }" 
          :class="{ active: isActive('price') }">
            Прайс-лист
        </router-link>
        <router-link 
          @click="updateCurrentRoute" 
          :to="{ name: 'profile' }" 
          :class="{ active: isActive('profile') }">
            Профиль
        </router-link>
      </div>
    </div>
    <div class="main-panel">
      <ContentLayout></ContentLayout>
    </div>
    <!-- <div class="main-panel">
      <keep-alive>
        <top-navbar :currentRoute="$route"></top-navbar>
      </keep-alive>
      <ContentLayout></ContentLayout>
    </div> -->
  </div>
</template>
<script>

// import TopNavbar from "../components/TopNavbar.vue";
import ContentLayout from "./ContentLayout.vue";
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'PortalLayout',
  components: {
    // TopNavbar,
    ContentLayout
  },
  
  data() {
    return {
      currentRoute: '',
      allCountNewMessages: 0,
    }
  },

  created() {
    this.getAllCountNewMessages();
    this.updateCurrentRoute();
  },

  watch: {
    '$route'() {
      this.getAllCountNewMessages();
    }
  },

  methods: {
    // save active button on right panel
    updateCurrentRoute(route) {
      this.currentRoute = route;
    },
    isActive(route) {
      return this.currentRoute === route;
    },

    async getAllCountNewMessages() {
      let res = await GlobalRequest.request("/order/draft", "GET")
      if(res.success) {
        let companyID = ""

        const values = Object.values(res.data.contrAgent);
        companyID = values[0].id
        // console.log("companyID = " + companyID)

        // companyID = res.data.partner.id
        if(!this.isEmpty(companyID)) {
          let resMessages = await GlobalRequest.request("/order-message/new-message-count/" + companyID, "GET")
          if(resMessages.success) {
            let messages = resMessages.data
            this.allCountNewMessages = Object.values(messages).reduce((sum, value) => sum + value, 0);
            // console.log(this.allCountNewMessages)
          }
        }
      }
    },

    isEmpty(data) {
      if(data != "" && data != " " && data != 0 && data != null) {
        if(data.length > 0) return false
      }
      else {
        return true
      }
    },
  },
};
</script>
